import { CmsCoexistenceGuide } from "@/components/cms/CmsCoexistenceGuide";
import CMSLayout from "@/layout/CMSLayout";

/** Guide accessible depuis l'ancien CMS (sans exiger le mode avancé). */
export default function CmsCoexistenceGuidePage() {
  return (
    <CMSLayout pageName="Guide CMS — coexistence" formIds={[]}>
      <div className="max-w-2xl">
        <CmsCoexistenceGuide />
      </div>
    </CMSLayout>
  );
}
